import { createFileRoute } from '@tanstack/react-router'
import { CreateDeliveryRequestPage } from '@/features/dashboard/delivery-request/pages/CreateDeliveryRequestPage'

export const Route = createFileRoute('/_dashboard/delivery-requests/create')({
  component: CreateDeliveryRequestPageComponent,
})

function CreateDeliveryRequestPageComponent() {
  return <CreateDeliveryRequestPage />
}
